import { FormShell, Field, useFormSubmit, Success } from "@/components/forms/FormShell";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";
import { Building2, TrendingUp, Users } from "lucide-react";

export default function Wholesale() {
  const { loading, done, submit } = useFormSubmit("/wholesale-application");
  const onSubmit = (e) => {
    e.preventDefault();
    submit(Object.fromEntries(new FormData(e.target)), api);
  };
  return (
    <FormShell
      kicker="Wholesale"
      title="Parts supply for automotive professionals"
      description="Qualified commercial buyers can request volume pricing, recurring inventory, product sourcing, and multi-unit order support."
    >
      <div className="grid md:grid-cols-3 gap-4 mb-8">
        {[
          { icon: Users, t: "Volume pricing", d: "Tiered discounts for repeat orders and multi-unit buys." },
          { icon: Building2, t: "Business terms", d: "Applications reviewed for repair shops, dealers, and fleets." },
          { icon: TrendingUp, t: "Recurring supply", d: "Ongoing inventory support for high-usage part numbers." },
        ].map((x) => (
          <div key={x.t} className="rounded-xl border border-slate-200 bg-slate-50 p-4">
            <x.icon className="w-5 h-5 text-[#0055FF]" />
            <div className="mt-3 font-heading font-semibold text-slate-900">{x.t}</div>
            <div className="text-xs text-slate-500 mt-1">{x.d}</div>
          </div>
        ))}
      </div>
      {done ? (
        <Success message="Application received. We'll review the details and respond within 2 business days." />
      ) : (
        <form onSubmit={onSubmit} className="space-y-5" data-testid="wholesale-form">
          <div className="grid md:grid-cols-2 gap-4">
            <Field label="Business name" name="business_name" required />
            <Field label="Contact name" name="contact_name" required />
            <Field label="Email" name="email" type="email" required />
            <Field label="Phone" name="phone" required />
            <Field label="Business address" name="business_address" />
            <Field label="Website" name="website" placeholder="https://" />
            <Field label="Business type" name="business_type" placeholder="Repair shop / dealer / reseller" />
            <Field label="Years in business" name="years_in_business" />
            <Field label="Estimated monthly volume ($)" name="monthly_volume" />
            <Field label="Preferred manufacturers" name="preferred_manufacturers" placeholder="Bosch, Denso, Delphi…" />
            <Field label="Product categories" name="product_categories" />
            <Field label="Resale certificate on file?" name="resale_certificate" placeholder="Yes / No / Pending" />
          </div>
          <div>
            <Label className="text-[10px] font-mono uppercase tracking-widest text-slate-500">Part number list</Label>
            <Textarea data-testid="field-part-list" name="part_number_list" rows={3} className="mt-1.5" placeholder="One part number per line" />
          </div>
          <div>
            <Label className="text-[10px] font-mono uppercase tracking-widest text-slate-500">Notes</Label>
            <Textarea data-testid="field-notes" name="notes" rows={3} className="mt-1.5" />
          </div>
          <p className="text-xs text-slate-500">All wholesale applications are reviewed. Approval is not automatic.</p>
          <Button type="submit" disabled={loading} className="bg-[#0055FF] hover:bg-[#0044CC] h-11 px-6" data-testid="wholesale-submit">
            {loading ? "Sending…" : "Submit wholesale application"}
          </Button>
        </form>
      )}
    </FormShell>
  );
}
